import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useForm } from "react-hook-form";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateCustomer } from "../../../helpers/urlConfig/apiFunctions";
import { successToastify } from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function CustomerEdit({
  modal_list,
  setmodal_list,
  tog_list,
  fetchData,
  editCustomerData,
}) {
  const { register, handleSubmit, reset } = useForm({
    defaultValues: editCustomerData,
  });

  const onSubmit = async (data) => {
    try {
      // Replace with your API endpoint
      data.updated_by = getSessionData("user_id");
      const response = await updateCustomer(data);

      if (response.statusCode === 200) {
        successToastify("Customer updated successfully");
        fetchData();
        setmodal_list(false);
        reset();
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      // Handle error
      console.error("Error updating product:", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <Modal
        isOpen={modal_list}
        toggle={() => {
          tog_list();
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          toggle={() => {
            tog_list();
          }}
        >
          {" "}
          Edit Customer{" "}
        </ModalHeader>
        <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <div className="mb-3" id="modal-id" style={{ display: "none" }}>
              <label htmlFor="id-field" className="form-label">
                ID
              </label>
              <input
                type="text"
                id="id-field"
                className="form-control"
                placeholder="ID"
                readOnly
              />
            </div>

            <div className="mb-3">
              <label htmlFor="customername-field" className="form-label">
                Customer Name
              </label>
              <input
                type="text"
                id="customername-field"
                className="form-control"
                placeholder="Enter Customer Name"
                required
                {...register("customer_name", {
                  required: "Customer Name is required",
                })}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="phone-field" className="form-label">
                Mobile Number
              </label>
              <input
                type="text"
                id="phone-field"
                className="form-control"
                placeholder="Enter Phone no."
                {...register("phone_number")}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="date-field" className="form-label">
                Address
              </label>
              <textarea
                type="text"
                id="phone-field"
                className="form-control"
                placeholder="Enter Address."
                {...register("address")}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="email-field" className="form-label">
                Place
              </label>
              <input
                type="text"
                id="email-field"
                className="form-control"
                placeholder="Enter Place"
                {...register("place")}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="email-field" className="form-label">
                GST Details
              </label>
              <input
                type="text"
                id="email-field"
                className="form-control"
                placeholder="Enter GST Details"
                {...register("gst_details")}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="email-field" className="form-label">
                Pan Card Details
              </label>
              <input
                type="text"
                id="email-field"
                className="form-control"
                placeholder="Enter Pan Card Details"
                {...register("pan_details")}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success" id="add-btn">
                Edit Customer
              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

export default CustomerEdit;
